module.exports = __webpack_public_path__ + "static/media/ic_reactjs.47ce6e77.png";